<div class="grid-container">
  <div class="grid-row grid-gap-1">
    <h2>{{getDashboardTitle(dashboardName)}}</h2>
  </div>
  <div class="grid-row grid-gap padding-y-2"> 
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
      <label  class="usa-label">&nbsp;  </label>
      <button type="button" class="usa-button" (click)="exportToExcel()">Export Full Data</button>   
    </div>
</div>
  <div class="grid-row grid-gap-1">
    <tableau-viz id='tableauViz' toolbar='hidden' >
      <viz-parameter id="accessIdParm" name="AccessID"/>
    </tableau-viz>
  </div>
</div>
